module.exports = __webpack_public_path__ + "media/markers/marker-gray-blue-f9f26865.svg";